module.exports = {
    "baseUrl": "https://api-v4.staging.iris-health.com",
    "systemName": "System dev",
    "chatServer": "",
    "newChatServer": "https://chat.staging.iris-health.com",
    "companyTitle": "Patient Chat | Iris Health",
    "metaTitle": "Iris Health Chat",
    "favicon": "%PUBLIC_URL%/iris/iconWhite.ico",
    "redirectUrl": "https://www.iris.health.com",
    "companyName": "Iris Health",
    "copyRight": "Iris Health is a trademark of its respective owner.",
    "companyKey": "iris"
}